// extracted by mini-css-extract-plugin
export var base = "_4s-0";
export var updateBanner = "_4s-1";